import { format as fnsFormat } from 'date-fns';

/**
 * Safely convert any timestamp value to a Date-compatible number.
 * Handles: Firestore Timestamps, ISO strings, epoch ms numbers, Date objects, undefined/null.
 */
export function toMs(value) {
  if (!value) return Date.now();
  if (typeof value === 'number') return value;
  if (typeof value?.toMillis === 'function') return value.toMillis();
  if (typeof value?.seconds === 'number') return value.seconds * 1000; // Firestore Timestamp shape
  if (value instanceof Date) return value.getTime();
  if (typeof value === 'string') {
    const parsed = new Date(value).getTime();
    return isNaN(parsed) ? Date.now() : parsed;
  }
  return Date.now();
}

/**
 * Safe wrapper around date-fns format().
 * Accepts any timestamp format (string, number, Date, Firestore Timestamp).
 */
export function fmt(value, pattern) {
  try {
    return fnsFormat(toMs(value), pattern);
  } catch {
    return '--:--';
  }
}
